<template>
  <div class="row product-form--gray pb-4 mb-4">
    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Długość produktu"
        fieldName="length"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Szerokość produktu"
        fieldName="width"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Wysokość produktu"
        fieldName="height"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Waga produktu netto [kg]"
        fieldName="weight_netto"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Waga produktu brutto [kg]"
        fieldName="weight_brutto"
        type="number"
      ></InputSimple>
    </div>
    <div class="col-xl-8"></div>

    <div class="col-xl-24">
      <hr />
    </div>

    <!-- Subkarton -->

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Subkarton - ilość"
        fieldName="subbox_items_count"
        type="number"
      ></InputSimple>
    </div>
    <div class="col-xl-16"></div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Subkarton - długość"
        fieldName="subbox_length"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Subkarton - szerokość"
        fieldName="subbox_width"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Subkarton - wysokość"
        fieldName="subbox_height"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Subkarton - waga netto"
        fieldName="subbox_weight_netto"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Subkarton - waga brutto"
        fieldName="subbox_weight_brutto"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8"></div>

    <div class="col-xl-24">
      <hr />
    </div>

    <!-- Kartony  -->
    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Karton - ilość"
        fieldName="box_items_count"
        type="number"
      ></InputSimple>
    </div>
    <div class="col-xl-16"></div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Karton - długość"
        fieldName="box_length"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Karton - szerokość"
        fieldName="box_width"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Karton - wysokość"
        fieldName="box_height"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Karton - waga netto"
        fieldName="box_weight_netto"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Karton - waga brutto"
        fieldName="box_weight_brutto"
        type="number"
      ></InputSimple>
    </div>
    <div class="col-xl-8"></div>

    <div class="col-xl-24">
      <hr />
    </div>

    <!-- Warstwa -->

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Warstwa - ilość sztuk"
        fieldName="layer_items_count"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Warstwa - ilość kartonów"
        fieldName="layer_boxes_count"
        type="number"
      ></InputSimple>
    </div>
    <div class="col-xl-8"></div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Warstwa - długość"
        fieldName="layer_length"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Warstwa - szerokość"
        fieldName="layer_width"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Warstwa - wysokość"
        fieldName="layer_height"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Warstwa - waga netto"
        fieldName="layer_weight_netto"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Warstwa - waga brutto"
        fieldName="layer_weight_brutto"
        type="number"
      ></InputSimple>
    </div>
    <div class="col-xl-8"></div>

    <div class="col-xl-24">
      <hr />
    </div>

    <!-- Palety -->

    <div class="col-24 col-xl-8">
      <InputTreeselect
        :options="dictionaries.pallete_types"
        :object="logisticsData"
        :isLoading="isLoading"
        fieldName="pallete_type_id"
        label="Rodzaj palety"
        :clearable="true"
      ></InputTreeselect>
    </div>
    <div class="col-xl-16"></div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Paleta - ilość sztuk"
        fieldName="pallete_items_count"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Paleta - ilość kartonów"
        fieldName="pallete_boxes_count"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Paleta - ilość warstw"
        fieldName="pallete_layers_count"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Paleta - długość"
        fieldName="pallete_length"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Paleta - szerokość"
        fieldName="pallete_width"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Paleta - wysokość"
        fieldName="pallete_height"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Paleta - waga netto"
        fieldName="pallete_weight_netto"
        type="number"
      ></InputSimple>
    </div>

    <div class="col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Paleta - waga brutto"
        fieldName="pallete_weight_brutto"
        type="number"
      ></InputSimple>
    </div>
    <div class="col-xl-24">
      <hr />
    </div>

    <div class="col-24 col-xl-8">
      <InputTreeselect
        :options="dictionaries.packagings"
        :object="logisticsData"
        :isLoading="isLoading"
        fieldName="product_packaging_id"
        label="Rodzaj opakowania"
        :clearable="true"
      ></InputTreeselect>
    </div>
    <div class="col-24 col-xl-8">
      <InputSimple
        :object="logisticsData"
        label="Materiał opakowania"
        fieldName="packaging_material"
        type="text"
      ></InputSimple>
    </div>
  </div>
</template>
<script>
import InputTreeselect from "./forms/InputTreeselect.vue";
import InputSimple from "./forms/InputSimple.vue";
export default {
  name: "LogisticsData",
  components: { InputSimple, InputTreeselect },
  mounted() {
    console.log(this.logisticsData);
  },
  props: {
    logisticsData: {
      type: Object,
      required: false,
    },
    dictionaries: {
      type: Object,
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>
